import React from "react";
import DatePickerInner from "./DatePickerInner";
import moment from "moment";
import "moment/locale/it";
import Calendar from "react-calendar";
import "./../pages/style.css";
import getChiusura from "../services/getChiusura";
import addChiusura from "../services/addChiusura";
import deleteChiusura from "../services/deleteChiusura";
import Cookies from "universal-cookie";
import MyDatePicker from "./NewDatePicker";

import {
  Delete as DeleteIcon,
  Clear as ClearIcon,
  SelectAll as SelectAllIcon,
  ClearAll as ClearAllIcon,
  DateRange as DateRangeIcon,
  Add as AddIcon,
} from "@material-ui/icons";
import Utils from "../utils/utils";
import {
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Typography,
  Box,
  Divider,
  Checkbox,
  FormControlLabel,
  Chip,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import { ExpandMore as ExpandMoreIcon } from "@material-ui/icons";

export default class GiorniListWidget extends React.Component {
  constructor(props) {
    super(props);

    this.mark = [];
    this.state = {
      value: [],
      selectedDates: [],
      rangeDialogOpen: false,
      startDate: "",
      endDate: "",
      selectedYear: new Date().getFullYear(),
      selectedMonth: "all",
    };

    const cookies = new Cookies();
    this.username = cookies.get("username", { path: "/" });
    this.token = cookies.get("token", { path: "/" });

    // Configura moment.js per l'italiano
    moment.locale("it");

    // Ref per i DatePicker del dialog
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();
  }

  async update() {
    var giorniChiusura = await getChiusura(this.username, this.token);
    var giorniArray = [];
    giorniChiusura.forEach((g) => giorniArray.push(g.day));

    this.setState({
      value: giorniArray,
      selectedDates: [], // Reset selezione quando aggiorniamo la lista
    });
  }

  async componentDidMount() {
    await this.update();
  }

  async removeAllDates() {
    if (
      window.confirm(
        `Sei sicuro di voler rimuovere tutti i ${this.state.value.length} giorni di chiusura?`
      )
    ) {
      for (let date of this.state.value) {
        await deleteChiusura(this.username, this.token, date);
      }
      await this.update();
    }
  }

  async removeSelectedDates() {
    if (this.state.selectedDates.length === 0) {
      alert("Seleziona almeno una data da rimuovere");
      return;
    }

    if (
      window.confirm(
        `Sei sicuro di voler rimuovere ${this.state.selectedDates.length} giorni selezionati?`
      )
    ) {
      for (let date of this.state.selectedDates) {
        await deleteChiusura(this.username, this.token, date);
      }
      await this.update();
    }
  }

  async removeSingleDate(date) {
    if (window.confirm(`Sei sicuro di voler rimuovere il giorno ${date}?`)) {
      await deleteChiusura(this.username, this.token, date);
      await this.update();
    }
  }

  toggleDateSelection(date) {
    const { selectedDates } = this.state;
    const index = selectedDates.indexOf(date);

    if (index === -1) {
      // Aggiungi alla selezione
      this.setState({
        selectedDates: [...selectedDates, date],
      });
    } else {
      // Rimuovi dalla selezione
      this.setState({
        selectedDates: selectedDates.filter((d) => d !== date),
      });
    }
  }

  selectAllDates() {
    this.setState({
      selectedDates: [...this.state.value],
    });
  }

  deselectAllDates() {
    this.setState({
      selectedDates: [],
    });
  }

  // Nuovi metodi per la selezione di periodi
  openRangeDialog() {
    this.setState({
      rangeDialogOpen: true,
      startDate: "",
      endDate: "",
    });
  }

  closeRangeDialog() {
    this.setState({
      rangeDialogOpen: false,
      startDate: "",
      endDate: "",
    });
  }

  async addDateRange() {
    const startDate = this.startDateRef.current?.getDate();
    const endDate = this.endDateRef.current?.getDate();

    if (!startDate || !endDate) {
      alert("Seleziona entrambe le date");
      return;
    }

    const start = moment(startDate);
    const end = moment(endDate);

    if (start.isAfter(end)) {
      alert("La data di inizio deve essere precedente alla data di fine");
      return;
    }

    // Genera tutte le date nel periodo
    const dates = [];
    let current = start.clone();
    while (current.isSameOrBefore(end)) {
      const dateStr = current.format("DD-MM-YYYY");

      // Controlla se ci sono lezioni in questo giorno
      let lezioni = await Utils.checkLessonsForDay(dateStr);
      if (lezioni.length > 0) {
        if (
          !window.confirm(
            `Il giorno ${dateStr} ha delle lezioni programmate (${lezioni}).\nVuoi continuare comunque?`
          )
        ) {
          return;
        }
      }

      dates.push(dateStr);
      current.add(1, "day");
    }

    // Aggiungi tutte le date
    for (let date of dates) {
      if (!this.state.value.includes(date)) {
        await addChiusura(this.username, this.token, date);
      }
    }

    await this.update();
    this.closeRangeDialog();
  }

  // Raggruppa date consecutive
  groupConsecutiveDates(dates) {
    if (dates.length === 0) return [];

    const sortedDates = dates
      .map((d) => moment(d, "DD-MM-YYYY"))
      .sort((a, b) => a - b);
    const groups = [];
    let currentGroup = [sortedDates[0]];

    for (let i = 1; i < sortedDates.length; i++) {
      const prevDate = sortedDates[i - 1];
      const currentDate = sortedDates[i];

      if (currentDate.diff(prevDate, "days") === 1) {
        // Date consecutive
        currentGroup.push(currentDate);
      } else {
        // Nuovo gruppo
        groups.push(currentGroup);
        currentGroup = [currentDate];
      }
    }
    groups.push(currentGroup);

    return groups.map((group) => {
      if (group.length === 1) {
        return {
          type: "single",
          start: group[0],
          dates: [group[0].format("DD-MM-YYYY")],
        };
      } else {
        return {
          type: "range",
          start: group[0],
          end: group[group.length - 1],
          dates: group.map((d) => d.format("DD-MM-YYYY")),
        };
      }
    });
  }

  // Filtra date per anno e mese
  getFilteredDates() {
    const { selectedYear, selectedMonth } = this.state;

    return this.state.value.filter((date) => {
      const momentDate = moment(date, "DD-MM-YYYY");
      const yearMatch = momentDate.year() === selectedYear;
      const monthMatch =
        selectedMonth === "all" ||
        momentDate.month() === parseInt(selectedMonth);
      return yearMatch && monthMatch;
    });
  }

  getDate() {
    return this.state.value;
  }

  render() {
    const filteredDates = this.getFilteredDates();
    const groupedDates = this.groupConsecutiveDates(filteredDates);
    const availableYears = [
      ...new Set(
        this.state.value.map((date) => moment(date, "DD-MM-YYYY").year())
      ),
    ].sort();
    const months = [
      { value: "all", label: "Tutti i mesi" },
      { value: 0, label: "Gennaio" },
      { value: 1, label: "Febbraio" },
      { value: 2, label: "Marzo" },
      { value: 3, label: "Aprile" },
      { value: 4, label: "Maggio" },
      { value: 5, label: "Giugno" },
      { value: 6, label: "Luglio" },
      { value: 7, label: "Agosto" },
      { value: 8, label: "Settembre" },
      { value: 9, label: "Ottobre" },
      { value: 10, label: "Novembre" },
      { value: 11, label: "Dicembre" },
    ];

    return (
      <div style={containerStyle}>
        <div style={calendarSection}>
          <Calendar
            id={Math.random()}
            locale="it-IT"
            calendarType="ISO 8601"
            formatShortWeekday={(locale, date) => {
              // Nomi abbreviati italiani per i giorni della settimana, iniziando da Lunedì
              const giorni = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];
              return giorni[date.getDay()];
            }}
            formatMonthYear={(locale, date) => {
              // Formatta mese e anno in italiano
              return moment(date)
                .locale("it")
                .format("MMMM YYYY");
            }}
            formatMonth={(locale, date) => {
              // Formatta il mese in italiano
              return moment(date)
                .locale("it")
                .format("MMMM");
            }}
            tileClassName={({ date, view }) => {
              if (
                this.state.value.find(
                  (x) => x === moment(date).format("DD-MM-YYYY")
                )
              ) {
                return "giornoChiusura";
              } else {
                return "react-calendar__tile";
              }
            }}
            onClickDay={async (date) => {
              var strDay = moment(date).format("DD-MM-YYYY");
              var index = this.state.value.indexOf(strDay);
              if (index != -1) {
                await deleteChiusura(this.username, this.token, strDay);
              } else {
                let lezioni = await Utils.checkLessonsForDay(strDay);
                if (lezioni.length > 0) {
                  alert(
                    "Impossibile aggiungere la chiusura\nEsistono delle lezioni per questo giorno:\n" +
                      lezioni
                  );
                  return;
                }
                await addChiusura(this.username, this.token, strDay);
              }

              this.update();
            }}
          ></Calendar>

          {/* Pulsante per selezione periodo */}
          <Box
            style={{
              marginTop: "15px",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<DateRangeIcon />}
              onClick={() => this.openRangeDialog()}
              style={{
                borderRadius: "8px",
                padding: "8px 16px",
                fontWeight: "bold",
                textTransform: "none",
              }}
            >
              Aggiungi Periodo
            </Button>
          </Box>
        </div>

        <div style={summarySection}>
          <Box style={summaryBox}>
            <Typography variant="h6" gutterBottom>
              Riepilogo Giorni di Chiusura
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              Totale giorni: {this.state.value.length}
              {this.state.selectedDates.length > 0 && (
                <Chip
                  size="small"
                  label={`${this.state.selectedDates.length} selezionati`}
                  color="primary"
                  style={{ marginLeft: "10px" }}
                />
              )}
            </Typography>

            {/* Filtri per anno e mese */}
            {this.state.value.length > 0 && (
              <Box
                style={{ display: "flex", gap: "10px", marginBottom: "10px" }}
              >
                <FormControl size="small" style={{ minWidth: 100 }}>
                  <InputLabel>Anno</InputLabel>
                  <Select
                    value={this.state.selectedYear}
                    onChange={(e) =>
                      this.setState({ selectedYear: e.target.value })
                    }
                  >
                    {availableYears.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl size="small" style={{ minWidth: 120 }}>
                  <InputLabel>Mese</InputLabel>
                  <Select
                    value={this.state.selectedMonth}
                    onChange={(e) =>
                      this.setState({ selectedMonth: e.target.value })
                    }
                  >
                    {months.map((month) => (
                      <MenuItem key={month.value} value={month.value}>
                        {month.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}

            <div style={buttonGroupStyle}>
              {this.state.value.length > 0 && (
                <>
                  <Button
                    variant="outlined"
                    color="secondary"
                    startIcon={<ClearIcon />}
                    onClick={() => this.removeAllDates()}
                    size="small"
                    style={{ marginRight: "8px" }}
                  >
                    Rimuovi Tutti
                  </Button>

                  {this.state.selectedDates.length > 0 && (
                    <Button
                      variant="contained"
                      color="secondary"
                      startIcon={<DeleteIcon />}
                      onClick={() => this.removeSelectedDates()}
                      size="small"
                      style={{ marginRight: "8px" }}
                    >
                      Rimuovi Selezionati
                    </Button>
                  )}

                  <Button
                    variant="text"
                    startIcon={<SelectAllIcon />}
                    onClick={() => this.selectAllDates()}
                    size="small"
                    style={{ marginRight: "8px" }}
                  >
                    Seleziona Tutti
                  </Button>

                  {this.state.selectedDates.length > 0 && (
                    <Button
                      variant="text"
                      startIcon={<ClearAllIcon />}
                      onClick={() => this.deselectAllDates()}
                      size="small"
                    >
                      Deseleziona
                    </Button>
                  )}
                </>
              )}
            </div>

            <Divider style={{ margin: "10px 0" }} />

            {/* Lista raggruppata dei giorni */}
            <div style={scrollContainerStyle}>
              <List dense style={listStyle}>
                {groupedDates.map((group, index) => {
                  if (group.type === "single") {
                    const date = group.dates[0];
                    return (
                      <ListItem key={index} style={listItemStyle}>
                        <Checkbox
                          checked={this.state.selectedDates.includes(date)}
                          onChange={() => this.toggleDateSelection(date)}
                          size="small"
                          color="primary"
                        />
                        <ListItemText
                          primary={date}
                          secondary={group.start.format("dddd, DD MMMM YYYY")}
                          style={{ marginLeft: "8px" }}
                        />
                        <ListItemSecondaryAction>
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => this.removeSingleDate(date)}
                            size="small"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    );
                  } else {
                    // Gruppo di date consecutive
                    return (
                      <Accordion key={index} style={{ margin: "2px 0" }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <Checkbox
                              checked={group.dates.every((date) =>
                                this.state.selectedDates.includes(date)
                              )}
                              indeterminate={
                                group.dates.some((date) =>
                                  this.state.selectedDates.includes(date)
                                ) &&
                                !group.dates.every((date) =>
                                  this.state.selectedDates.includes(date)
                                )
                              }
                              onChange={() => {
                                const allSelected = group.dates.every((date) =>
                                  this.state.selectedDates.includes(date)
                                );
                                if (allSelected) {
                                  // Deseleziona tutti del gruppo
                                  this.setState({
                                    selectedDates: this.state.selectedDates.filter(
                                      (date) => !group.dates.includes(date)
                                    ),
                                  });
                                } else {
                                  // Seleziona tutti del gruppo
                                  const newSelected = [
                                    ...this.state.selectedDates,
                                  ];
                                  group.dates.forEach((date) => {
                                    if (!newSelected.includes(date)) {
                                      newSelected.push(date);
                                    }
                                  });
                                  this.setState({ selectedDates: newSelected });
                                }
                              }}
                              size="small"
                              color="primary"
                              onClick={(e) => e.stopPropagation()}
                            />
                            <div style={{ marginLeft: "8px", flex: 1 }}>
                              <Typography variant="body2">
                                <strong>
                                  Periodo: {group.start.format("DD/MM/YYYY")} -{" "}
                                  {group.end.format("DD/MM/YYYY")}
                                </strong>
                              </Typography>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                              >
                                {group.dates.length} giorni:{" "}
                                {group.start.format("dddd DD MMMM")} -{" "}
                                {group.end.format("dddd DD MMMM YYYY")}
                              </Typography>
                            </div>
                            <IconButton
                              edge="end"
                              aria-label="delete"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (
                                  window.confirm(
                                    `Vuoi rimuovere tutto il periodo dal ${group.start.format(
                                      "DD/MM/YYYY"
                                    )} al ${group.end.format("DD/MM/YYYY")} (${
                                      group.dates.length
                                    } giorni)?`
                                  )
                                ) {
                                  group.dates.forEach(async (date) => {
                                    await deleteChiusura(
                                      this.username,
                                      this.token,
                                      date
                                    );
                                  });
                                  this.update();
                                }
                              }}
                              size="small"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails>
                          <List dense style={{ width: "100%", paddingTop: 0 }}>
                            {group.dates.map((date) => (
                              <ListItem
                                key={date}
                                style={{
                                  ...listItemStyle,
                                  paddingLeft: "32px",
                                }}
                              >
                                <Checkbox
                                  checked={this.state.selectedDates.includes(
                                    date
                                  )}
                                  onChange={() =>
                                    this.toggleDateSelection(date)
                                  }
                                  size="small"
                                  color="primary"
                                />
                                <ListItemText
                                  primary={date}
                                  secondary={moment(date, "DD-MM-YYYY").format(
                                    "dddd, DD MMMM YYYY"
                                  )}
                                  style={{ marginLeft: "8px" }}
                                />
                                <ListItemSecondaryAction>
                                  <IconButton
                                    edge="end"
                                    aria-label="delete"
                                    onClick={() => this.removeSingleDate(date)}
                                    size="small"
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </ListItemSecondaryAction>
                              </ListItem>
                            ))}
                          </List>
                        </AccordionDetails>
                      </Accordion>
                    );
                  }
                })}
                {filteredDates.length === 0 && this.state.value.length > 0 && (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    Nessun giorno trovato per i filtri selezionati
                  </Typography>
                )}
                {this.state.value.length === 0 && (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    Nessun giorno di chiusura selezionato
                  </Typography>
                )}
              </List>
            </div>
          </Box>
        </div>

        {/* Dialog per selezione periodo */}
        <Dialog
          open={this.state.rangeDialogOpen}
          onClose={() => this.closeRangeDialog()}
        >
          <DialogTitle>
            <DateRangeIcon
              style={{ marginRight: "10px", verticalAlign: "middle" }}
            />
            Aggiungi Periodo di Chiusura
          </DialogTitle>
          <DialogContent>
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ marginBottom: "20px" }}
            >
              Seleziona la data di inizio e fine per aggiungere un periodo di
              chiusura. Tutti i giorni compresi nel periodo verranno aggiunti
              automaticamente.
            </Typography>
            <Box
              style={{ display: "flex", flexDirection: "column", gap: "15px" }}
            >
              <MyDatePicker
                ref={this.startDateRef}
                name="Data inizio"
                selected={
                  this.state.startDate ? new Date(this.state.startDate) : null
                }
                onChange={(date) => {
                  const dateStr = date ? moment(date).format("YYYY-MM-DD") : "";
                  this.setState({ startDate: dateStr });
                }}
              />
              <MyDatePicker
                ref={this.endDateRef}
                name="Data fine"
                selected={
                  this.state.endDate ? new Date(this.state.endDate) : null
                }
                onChange={(date) => {
                  const dateStr = date ? moment(date).format("YYYY-MM-DD") : "";
                  this.setState({ endDate: dateStr });
                }}
              />
              {this.startDateRef.current?.getDate() &&
                this.endDateRef.current?.getDate() && (
                  <Paper
                    style={{ padding: "10px", backgroundColor: "#f5f5f5" }}
                  >
                    <Typography variant="body2">
                      <strong>Anteprima:</strong> Verranno aggiunti{" "}
                      {moment(this.endDateRef.current.getDate()).diff(
                        moment(this.startDateRef.current.getDate()),
                        "days"
                      ) + 1}{" "}
                      giorni dal{" "}
                      {moment(this.startDateRef.current.getDate()).format(
                        "DD/MM/YYYY"
                      )}{" "}
                      al{" "}
                      {moment(this.endDateRef.current.getDate()).format(
                        "DD/MM/YYYY"
                      )}
                    </Typography>
                  </Paper>
                )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.closeRangeDialog()}>Annulla</Button>
            <Button
              onClick={() => this.addDateRange()}
              color="primary"
              variant="contained"
              disabled={
                !this.startDateRef.current?.getDate() ||
                !this.endDateRef.current?.getDate()
              }
            >
              Aggiungi Periodo
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const containerStyle = {
  display: "flex",
  gap: "20px",
  padding: "5px",
  flexWrap: "wrap",
};

const calendarSection = {
  flex: "1",
  minWidth: "300px",
};

const summarySection = {
  flex: "1",
  minWidth: "300px",
};

const summaryBox = {
  border: "1px solid #e0e0e0",
  borderRadius: "8px",
  padding: "15px",
  backgroundColor: "#fafafa",
  height: "fit-content",
  maxHeight: "500px",
  display: "flex",
  flexDirection: "column",
};

const buttonGroupStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "4px",
  marginBottom: "10px",
};

const scrollContainerStyle = {
  flex: "1",
  overflow: "hidden",
};

const listStyle = {
  maxHeight: "300px",
  overflow: "auto",
  border: "1px solid #f0f0f0",
  borderRadius: "4px",
};

const listItemStyle = {
  borderBottom: "1px solid #f0f0f0",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
  "&:last-child": {
    borderBottom: "none",
  },
};

const mainClass = {
  padding: "5px",
};

const name = {};

const inputText = {
  width: "300px",
  padding: "10px",
};
